function getVariables($$) {
  const { theme } = $$;
  const $ = {};

  $.white = theme.colors.white ?? '#fff';
  $.gray100 = theme.colors.gray100 ?? '#f5f5f5';
  $.gray200 = theme.colors.gray200 ?? '#eeeeee';
  $.gray300 = theme.colors.gray300 ?? '#e0e0e0';
  $.gray400 = theme.colors.gray400 ?? '#bdbdbd';
  $.gray500 = theme.colors.gray500 ?? '#9e9e9e';
  $.gray600 = theme.colors.gray600 ?? '#757575';
  $.gray700 = theme.colors.gray700 ?? '#616161';
  $.gray800 = theme.colors.gray800 ?? '#424242';
  $.gray900 = theme.colors.gray900 ?? '#212121';
  $.black = theme.colors.black ?? '#000';

  $.grays = {
    '100': $.gray100,
    '200': $.gray200,
    '300': $.gray300,
    '400': $.gray400,
    '500': $.gray500,
    '600': $.gray600,
    '700': $.gray700,
    '800': $.gray800,
    '900': $.gray900,
  };

  $.blue = '#2196f3';
  $.indigo = '#3f51b5';
  $.purple = '#673ab7';
  $.pink = '#e91e63';
  $.red = '#f44336';
  $.orange = '#ff9800';
  $.yellow = '#ffeb3b';
  $.green = '#4caf50';
  $.teal = '#009688';
  $.cyan = '#00bcd4';
  // End of Material UI Color System

  // BxThemeProvider Colors
  // Colors
  $.primaryMain = '#0b1955';
  $.primaryTextMain = $.white;
  $.secondaryMain = '#9cbe4a';
  $.infoMain = '#3c8ef7';
  $.warningMain = '#f8d161';
  $.successMain = '#4caf50';
  $.dangerMain = '#f44336';
  $.primaryMain = theme.colors.primary;
  $.primaryTextMain = $.white;
  $.secondaryMain = theme.colors.secondary;
  $.infoMain = theme.colors.info;
  $.warningMain = theme.colors.warning;
  $.successMain = theme.colors.success;
  $.dangerMain = theme.colors.danger;

  $.dangerMainBg = '#f0776e';

  // Theme palette
  $.zebraListItem_1 = '#f0efee';

  // Additional colors
  $.deltaRed = '#a15751'; // HeatMapCell
  $.deltaGreen = '#bed6b0'; // HeatMapCell
  $.red2 = '#bd8986'; // Progress Bar
  // End of BxThemeProvider Colors

  $.slaRed = '#ff0000';
  $.slaGreen = '#00ff00';
  $.slaYellow = '#ffff00';

  $.borderRadius = '4px';
  $.borderRadiusLg = '8px';
  $.borderRadiusSm = '2px';

  // form style
  $.inlineInputGap = '1.5rem';
  $.inlineLabelGap = '0.5rem';

  $.gridBreakpoints = {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1780px',
  };

  $.sidebarButtonWidth = '3.5rem';
  $.sidebarContentWidth = '3.5rem';

  $.mainContainerGap = '24px';

  // navbar
  $.navbarHeight = '3rem';

  // Font family
  $.fontFamily = theme.font.fontFamily ?? 'Arial';
  $.headingsFontFamily = $.fontFamily;

  return $;
}

export default getVariables;
